// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { LocaleProvider } from '@plesk/ui-library';
import ErrorPage from 'common/components/ErrorPage';
import Cookie from 'common/cookie';

const fallbackLocale = {
    title: 'Server Error',

    repairKitDescription: 'You may be able to resolve the issue automatically using the Repair Kit.',
    repairKitAdminDescription: 'If you are the server\'s administrator, you can try resolving the issue using the Repair Kit, our troubleshooting tool.',
    repairKitOpen: 'Open the Repair Kit',
    repairKitOpenNote: 'You will be asked to enter the Plesk administrator password.',
    repairKitUnavailable: 'Repair Kit is unavailable. To restore it, log in to the server via SSH,' +
        ' run the command \'systemctl restart plesk-repaird.service\', and then refresh this page.',

    reportErrorMessage: 'Need help resolving the issue?',
    visitHelpCenter: 'Visit Plesk Help Center.',

    networkError: 'Network error',
    networkErrorDescription: 'Your connection is unstable.',

    helpActions: 'That\'s what you can do',
    reloadPage: 'Reload Page',
    backToPreviousPage: 'Back to Previous Page',
    homePage: 'Home Page',
    searchKbArticle: 'Search for related Knowledge Base articles',
    invalidUrl: 'Invalid URL was requested.',

    reportProblem: 'Report a problem',
    documentation: 'Documentation',
    knowledgeBase: 'Knowledge base',
    forum: 'Forum',
    youTube: 'YouTube',
    facebook: 'Facebook',
};

const reportToUat = {
    500: new Set(['Plesk\\Exception\\Database']),
};

const App = ({ locale = {}, ...props }) => {
    useEffect(() => {
        setTimeout(() => {
            const reportCode = reportToUat[props.code];
            if (reportCode && reportCode.has(props?.exception?.type)) {
                const { code, exception: { type, message } = {} } = props;
                window.Jsw.UAT.dispatchAction('ERROR_DOCUMENT', { code, type, message });
            }
        });
    }, [props]);

    return (
        <LocaleProvider messages={{ ...fallbackLocale, ...locale }}>
            <ErrorPage {...props} />
            {'true' === Cookie.get('debug-testing-mode') ? (
                <div id="bottomAnchor" style={{ position: 'fixed', top: 0, zIndex: -1, opacity: 0.001 }}>{Date.now()}</div>
            ) : null}
        </LocaleProvider>
    );
};

App.propTypes = {
    locale: PropTypes.object,
    code: PropTypes.string,
    exception: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string,
    }),
};

export default App;
